import React from "react";
import Icon from "../../ui/Icon";
import CartFilters from "../cart/CartFilters";
import { useCart } from "../../contexts/CartContext";

function CartItem({ item }) {
  const {
    handleDecQuantityAndPrice,
    handleIncQuantityAndPrice,
    handleRemoveFromCart,
  } = useCart();

  return (
    <li className="mb-8 grid grid-cols-[auto_1fr] gap-x-12">
      {/* Image container */}
      <div className="h-48 w-48 border">
        {/* Image */}
        <img
          src={item.image}
          alt="Product images"
          className="block h-full w-full object-cover"
        />
      </div>
      {/* Content */}
      <div className="flex flex-col justify-center">
        {/* Name, price, color and size container */}
        <div>
          <h3 className="mb-4 text-base font-bold capitalize md:text-3xl">
            {item.name}
          </h3>
          <CartFilters type="Price" price={item.price} />
          <CartFilters type="Color" color={item.color} />
          <CartFilters type="Size" size={item.size} />
        </div>

        {/* Quantity and delete container */}
        <div className="mt-auto flex items-center gap-4">
          {/* Quantity container with border */}
          <div className="flex items-center gap-4 border border-black px-2 py-1">
            <button
              type="button"
              className={`${
                item.quantity === 1
                  ? "cursor-not-allowed"
                  : "cursor-pointer text-2xl"
              }`}
              onClick={() => handleDecQuantityAndPrice(item.id, item.size)}
            >
              −
            </button>
            <div className="font-semibold">{item.quantity}</div>
            <button
              className="cursor-pointer text-2xl"
              onClick={() => handleIncQuantityAndPrice(item.id, item.size)}
            >
              +
            </button>
          </div>
          {/* Delete container */}
          <div onClick={() => handleRemoveFromCart(item.id, item.size)}>
            <Icon textColor="black">
              <ion-icon name="trash-bin-outline" size="medium"></ion-icon>
            </Icon>
          </div>
        </div>
      </div>
    </li>
  );
}

export default CartItem;
